import styled from 'styled-components';
import { Alert, Link } from '@mui/material';

export const OfflineAlert = styled(Alert)`
  && {
    margin-bottom: 24px;
    width: 100%;
    box-sizing: border-box;
    background-color: #0d4efe;
    color: #ffffff;
    font-weight: 600;
    border-left: 8px solid #01ebb2;
    border-radius: 12px;
    padding: 20px 22px;
    font-size: 1.125rem;
    line-height: 1.55;
    align-items: flex-start;
  }

  && .MuiAlert-icon {
    color: #ffffff;
    padding-top: 4px;
    margin-right: 14px;
    opacity: 1;
  }

  && .MuiAlert-icon .MuiSvgIcon-root {
    font-size: 2rem;
  }

  && .MuiAlert-message {
    padding: 6px 0 0;
    font-size: inherit;
    line-height: inherit;
    width: 100%;
  }

  && strong {
    font-weight: 800;
  }

  @media (min-width: 900px) {
    && {
      font-size: 1.375rem;
      padding: 24px 28px;
      line-height: 1.5;
    }

    && .MuiAlert-icon .MuiSvgIcon-root {
      font-size: 2.25rem;
    }
  }
`;

export const OfflineContactLink = styled(Link)`
  && {
    color: inherit;
    font-weight: 800;
  }

  &&:hover {
    color: #ffffff;
    opacity: 0.92;
  }
`;
